export const getInitialState = () => ({
    offers: {},
    referralDiscount: {}
});

export const homeReducers = (state = getInitialState(), action) => {
    switch (action.type) {
        case 'FETCH_OFFERS': {
            const {referralDiscount, promotions } = action?.payload;
            return {...state, referralDiscount, offers: promotions};
        }

        default:
            return state;
    }
};
